export type allColours =
	| 'black'
	| 'white'
	| 'darkWhite'
	| 'lightGrey'
	| 'grey'
	| 'darkGrey'
	| 'blueGrey'
	| 'darkBlueGrey'
	| 'lightestBlue'
	| 'lighterBlue'
	| 'lightBlue'
	| 'blue'
	| 'primaryBlue'
	| 'lightPurple'
	| 'purple'
	| 'green'
	| 'greenSuccess'
	| 'redFailed'
	| 'red'
	| 'yellow' 
	| 'scarlett' 
	| 'gold' ;

export const colours: Record<allColours, string> = {
	black: '#243359',
	white: '#ffffff',
	darkWhite: '#f5f6fa',
	lightGrey: '#ece9f1',
	grey: '#e5e5e5',
	darkGrey: '#a2a3a5',
	blueGrey: '#66718b',
	darkBlueGrey: '#44547f',
	lightestBlue: '#f2f6ff',
	lighterBlue: '#f0f6ff',
	lightBlue: '#e5f0ff',
	blue: '#54c1fc',
	primaryBlue: '#272848',
	lightPurple: '#f2f4fa',
	purple: '#b8cbfc',
	green: '#3fca54',
	greenSuccess: '#bee3b6',
	red: '#f46036',
	redFailed: '#ff9d9d',
	yellow: '#fff05a',
	gold: '#ffd700',
	scarlett: '#9e3737',
};

export const darkerColours: Record<allColours, string> = {
	black: '#0',
	white: '#0',
	darkWhite: '#0',
	lightGrey: '#0',
	grey: '#0',
	darkGrey: '#0',
	blueGrey: '#0',
	darkBlueGrey: '#0',
	lightestBlue: '#0',
	lighterBlue: '#0',
	lightBlue: '#0',
	blue: '#54c1fc',
	primaryBlue: '#272848',
	lightPurple: '#0',
	greenSuccess: '#0',
	redFailed: '#0',
	purple: '#0',
	green: '#1c6728',
	red: '#8d2507',
	yellow: '#ac9c00',
	gold: '#ffd700',
	scarlett: '#9e3737',
};


export type ChartColours = 'blue' | 'black' | 'grey'

export const chartColours: Record<ChartColours, {
	main: string,
	light: string,
}> = {
	black: {
		main: 'rgba(36, 51, 89, 1)',
		light: 'rgba(36, 51, 89, .3)',
	},	
	blue: {
		main: 'rgba(132, 160, 194, 1)',
		light: 'rgba(132, 160, 194, .3)',
	},	
	grey: {
		main: 'rgba(162, 163, 165, 1)',
		light: 'rgba(162, 163, 165, .3)',
	}	
}